module.exports = __webpack_public_path__ + "img/level_7.937b2645.svg";